import Alertas from '@/repositories/Alertas';

const state = () => ({
    alertas: [],
    alertaSubstOrigem: null,
    exibeAlerta: false,
});

const getters = {
    getAlertas: (state) => {
        return state.alertas
    },

    getAlertaSubstOrigem: (state) => {
        return state.alertaSubstOrigem
    },

    getExibeAlerta: (state) => {
        return state.exibeAlerta
    }
};

const mutations = {
    SET_ALERTAS (state, alertas) {
        state.alertas = alertas
    },

    SET_ALERTA_SUBST_ORIGEM (state, alertaSubstOrigem) {
        state.alertaSubstOrigem = alertaSubstOrigem
    },

    SET_EXIBE_ALERTA (state, booleano) {
        state.exibeAlerta = booleano
    }
};

const actions = {
    async fetchAlertas({commit}) {
        const dados = await Alertas.getAlertas()

        commit('SET_ALERTAS', dados)
    },

    setAlertaSubstOrigem({commit}, alerta) {
        commit('SET_ALERTA_SUBST_ORIGEM', alerta)
    },

    setExibeAlerta({commit}, booleano) {
        commit('SET_EXIBE_ALERTA', booleano)
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};